import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

 
export type WithoutChild<T> = T extends { child?: any } ? Omit<T, "child"> : T;
 
export type WithoutChildren<T> = T extends { children?: any } ? Omit<T, "children"> : T;
export type WithoutChildrenOrChild<T> = WithoutChildren<WithoutChild<T>>;
export type WithElementRef<T, U extends HTMLElement = HTMLElement> = T & { ref?: U | null };

// 🌐 i18n 헬퍼 - API 응답의 i18n 객체에서 현재 로케일 텍스트 추출
// 서버에서 {"ko":"체중", "en":"Weight"} 형태로 내려오는 필드를 문자열로 변환
export function i18n(value: unknown, locale: string = 'ko'): string {
	if (!value) return '';
	if (typeof value === 'string') return value;
	if (typeof value === 'object' && value !== null) {
		const obj = value as Record<string, string>;
		return obj[locale] || obj['en'] || obj['ko'] || Object.values(obj)[0] || '';
	}
	return String(value);
}

// 🇰🇷 한국 시간대 (UTC+9) 유틸리티 함수들
export function getKSTDate(date?: Date): Date {
	const targetDate = date || new Date();
	const kstOffset = 9 * 60; // UTC+9 (분 단위)
	return new Date(targetDate.getTime() + (kstOffset * 60 * 1000));
}

export function getKSTDateString(date?: Date): string {
	return getKSTDate(date).toISOString().split('T')[0];
}

export function getKSTDateTime(date?: Date): string {
	return getKSTDate(date).toISOString().replace('T', ' ').substring(0, 19);
}

export function formatKSTDate(date?: Date, format: 'date' | 'datetime' | 'time' = 'date'): string {
	const kstDate = getKSTDate(date);

	switch (format) {
		case 'date':
			return kstDate.toISOString().split('T')[0];
		case 'datetime':
			return kstDate.toISOString().replace('T', ' ').substring(0, 19);
		case 'time':
			return kstDate.toISOString().split('T')[1].substring(0, 8);
		default:
			return kstDate.toISOString().split('T')[0];
	}
}
